import { InfoStepsItem } from 'components/infoSteps';
import { createContext } from 'react';

import { CtPlatform, CtPlatformBaseItem, UserSettings } from './general';
import { TableSettings } from './table';
import { ThemeName } from './theme';

export enum ImportSectionEnum {
  CARDS = 1,
  OPTIONS = 2,
  FORM = 3,
  SUCCESS_API = 4,
  SUCCESS_CSV = 5,
}

export interface ImportSection<D> {
  data?: D;
}

export interface ImportActiveSection<T> {
  data: ImportSectionEnum;
  ref?: T;
  instructions?: string | InfoStepsItem[];
}

export interface StoreState {
  step: number;
  setStep: (data: number) => void;
  platform?: CtPlatform;
  setPlatform: (data: CtPlatform) => void;
  baseItems?: CtPlatformBaseItem[];
  setBaseItems: (data: CtPlatformBaseItem[]) => void;
  importTableSettings?: TableSettings;
  setImportTableSettings: (data: TableSettings | undefined) => void;
  activeSection?: ImportActiveSection<unknown> | undefined;
  setActiveSection: (data: ImportActiveSection<unknown> | undefined) => void;
  importType?: ImportSection<string>;
  setImportType: (data: ImportSection<string>) => void;
  importName?: ImportSection<string>;
  setImportName: (data: ImportSection<string>) => void;
  userSettings?: UserSettings,
  setUserSettings: (data: UserSettings) => void;
  themeName: ThemeName;
  setThemeName: (data: ThemeName) => void;
  isProPage?: boolean;
  setIsProPage: (data: boolean | undefined) => void;
  isIntegrationsPage?: boolean;
  setIsIntegrationsPage: (data: boolean | undefined) => void;
}

export const StoreStateInitData = {
  step: 0,
  setStep: () => { },
  platform: undefined,
  setPlatform: () => { },
  options: undefined,
  setBaseItems: () => { },
  importTableSettings: undefined,
  setImportTableSettings: () => { },
  activeSection: undefined,
  setActiveSection: () => { },
  importType: undefined,
  setImportType: () => { },
  importName: undefined,
  setImportName: () => { },
  userSettings: {} | undefined,
  setUserSettings: () => { },
  themeName: ThemeName.LIGHT,
  setThemeName: () => { },
  setIsProPage: () => { },
  setIsIntegrationsPage: () => { },
};

export const StoreContext = createContext<StoreState>(StoreStateInitData);
